import { SAMPLE_SLAVERY_NEVER_ENDED, SAMPLE_GUIDANCE_DIRECTIONS, SAMPLE_HOUSE_OF_KHALIL_METHOD } from "@/lib/bookSamples";

export const STORE_URL = "https://books.by/beason";

export const BOOKS = [
  {
    slug: "slavery-never-ended",
    title: "Slavery Never Ended: Truth Never Dies",
    subtitle: "The Roots of Hatred Against “Blacks” in America",
    author: "Attorney John R. Beason-JR III",
    price: "US$23.99",
    format: "Paperback",
    cover: "/books/slavery-never-ended.jpg",
    url: STORE_URL,
    blurb:
      "Delves into the root causes of customary racism against Black Americans in the United States. Born in 1984, Attorney John R. Beason III uses his own life experiences as a Black American born into the Crack-Cocaine Epidemic and Black American international cultural dominance to explore the root causes of racism against Blacks in America — traversing history, genealogy, religion, sociology, human nature, and media entertainment to reveal what factors caused and sustain the current condition of 21st-century Black Americans.",
    featured: true,
    sample: SAMPLE_SLAVERY_NEVER_ENDED,
  },
  {
    slug: "guidance-directions-towards",
    title: "Guidance Directions Towards Good Deeds",
    subtitle: "The BOS Codes of Order",
    author: "Yahya Khalil, Bey",
    price: "US$19.99",
    format: "Paperback",
    cover: "/books/guidance-directions.jpg",
    url: `${STORE_URL}/guidance-directions-towards`,
    sample: SAMPLE_GUIDANCE_DIRECTIONS,
    blurb:
      "A rich heritage and system of codes, conduct, and community order for Black Liberation and Excellence. This work serves as practical guidance and timeless, divine principles to build strong individuals, families, and communities.",
  },
  {
    slug: "the-house-of-khalil-method",
    title: "The House of Khalil Method",
    subtitle: "A Jurisprudence & Methodology for Disciplined Historical Investigation",
    author: "Yahya Khalil, Bey",
    price: "US$30.99",
    format: "Paperback",
    cover: "/books/house-of-khalil-method.jpg",
    url: `${STORE_URL}/the-house-of-khalil-method`,
    sample: SAMPLE_HOUSE_OF_KHALIL_METHOD,
    blurb: "A foundational framework establishing historical truth through the Cumulative Record.",
  },
];

const totalCents = BOOKS.reduce((sum, b) => sum + Math.round(parseFloat(b.price.replace(/[^0-9.]/g, "")) * 100), 0);
export const COLLECTION_TOTAL = `US$${(totalCents / 100).toFixed(2)}`;

export const AUTHOR = {
  name: "John R. Beason III, Esq.",
  penName: "Yahya Khalil, Bey",
  publisher: "House of Khalil Publishing",
  photo: "/books/author.jpg",
  bio: [
    "John R. Beason III, Esq., writing as Yahya Khalil, Bey, is an attorney, author, independent scholar, human rights activist, and founder of House of Khalil Publishing. A native of Benton Harbor, Michigan, his work explores law, history, theology, Black American identity, self-determination, and the relationship between spiritual principles and community development.",
    "Drawing from his legal training, religious study, and lived experience within Black American communities, Beason approaches scholarship with an emphasis on questioning inherited narratives, examining primary sources, and developing independent frameworks for understanding history and contemporary society. His writing seeks to make complex legal, historical, and theological subjects accessible without sacrificing intellectual depth.",
    "Through House of Khalil Publishing, Beason is building a platform for scholarship that encourages critical thought, intellectual independence, and the pursuit of Truth, Justice, and Legacy. His work reflects a broader commitment to preserving Black American history, strengthening community institutions, and producing ideas intended not merely to describe the world, but to help future generations shape it.",
  ],
};
